import Vue from 'vue';
import wspVue from './components/el-index.vue';
const WeSelectPersonConstructor = Vue.extend(wspVue);
export const openSelectPerson = (options, reslove, reject) => {
  const props = {
    plugins: options.plugins
  };
  delete options.plugins;
  const instance = new WeSelectPersonConstructor({
    data: options,
    propsData: props
  });

  if (!instance.openDialog) {
    instance.$mount();
    document.body.appendChild(instance.$el);
    const oldCb = instance.callback;

    instance.callback = (selected, action) => {
      if (action === 'confirm') {
        if (typeof oldCb === 'function') {
          oldCb(selected);
        }

        if (reslove) {
          reslove(selected);
        }
      } else if (action === 'cancel' || action === 'close') {// if (reject) {
        //   reject(selected)
        // }
      }
    };

    instance.openDialog = true;
  }
}; // 支持指令式调用this.$SelectPerson()

export const SelectPerson = (options, callback) => {
  if (Vue.prototype.$isServer) return; // options参数：selectedUserList、plugins、callback

  if (!options.callback && callback) {
    options.callback = callback;
  }

  if (typeof Promise !== 'undefined') {
    return new Promise((resolve, reject) => {
      openSelectPerson(options, resolve, reject);
    });
  } else {
    openSelectPerson(options);
  }
};
Vue.prototype.$SelectPerson = SelectPerson; // Vue.component(wspVue.name, wspVue)

export default {
  SelectPerson
}; // export { SelectPerson }